/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoGoogleStoreProductImageUpdateRequest model module.
 * @module model/SystemControllerDtoGoogleStoreProductImageUpdateRequest
 * @version 1.0
 */
class SystemControllerDtoGoogleStoreProductImageUpdateRequest {
    /**
     * Constructs a new <code>SystemControllerDtoGoogleStoreProductImageUpdateRequest</code>.
     * @alias module:model/SystemControllerDtoGoogleStoreProductImageUpdateRequest
     * @param file {File} 
     */
    constructor(file) { 
        
        SystemControllerDtoGoogleStoreProductImageUpdateRequest.initialize(this, file);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, file) { 
        obj['file'] = file;
    }

    /**
     * Constructs a <code>SystemControllerDtoGoogleStoreProductImageUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoGoogleStoreProductImageUpdateRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoGoogleStoreProductImageUpdateRequest} The populated <code>SystemControllerDtoGoogleStoreProductImageUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoGoogleStoreProductImageUpdateRequest();

            if (data.hasOwnProperty('file')) {
                obj['file'] = ApiClient.convertToType(data['file'], File);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoGoogleStoreProductImageUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoGoogleStoreProductImageUpdateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoGoogleStoreProductImageUpdateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoGoogleStoreProductImageUpdateRequest.RequiredProperties = ["file"];

/**
 * @member {File} file
 */
SystemControllerDtoGoogleStoreProductImageUpdateRequest.prototype['file'] = undefined;






export default SystemControllerDtoGoogleStoreProductImageUpdateRequest;

